// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CustomerGroupService = {};

CustomerGroupService.postCustomerGroup = function (data) {
  return lossClient({
    url: "/CustomerGroup/add",
    method: "post",
    data: data,
  });
};

CustomerGroupService.getCustomerGroupList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 
  return lossClient({
    url:
      "/customergroup/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput.name,
    // +
    // "&desc=" +
    // userInput.desc +
    // "&status=" +
    // userInput.status,
    method: "get",
  });
};

CustomerGroupService.updateCustomerGroup = function (data) {
  const { Id, ...requestBody } = data;

  return lossClient({
    url: "/CustomerGroup/edit",
    method: "put",
    headers: {
      "x-requestid": Id,
    },
    data: requestBody,
  });
};

CustomerGroupService.deleteCustomerGroup = function (data) {
  const { CustomerGroupId, ...requestBody } = data;
  return lossClient({
    url: "/CustomerGroup/delete",
    method: "delete",
    headers: {
      "x-requestid": data.CustomerGroupId,
    },
    data: requestBody,
  });
};

export default CustomerGroupService;
